import { render } from "./NewsHKListing.vue?vue&type=template&id=249bcb43&scoped=true"
const script = {}

import "./NewsHKListing.vue?vue&type=style&index=0&id=249bcb43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249bcb43"]])

export default __exports__